import './../App.css';
import '../css/pages/contact.css';
import { useEffect, useState } from 'react';
import bg from "../img/Chantiers/Rénovation_Complète/Chantier_Jean_de_La_Fontaine/1_après.jpg";
import sofa from "../img/section-bg-2.png"
import Axios from 'axios'
import { apiUrl } from '../constants/Constants';
import { DevisToggleItemsType1, DevisToggleItemsType2, FooterComponent, FooterMainComponent } from '../components/MainComponents';
import { AiFillHome, AiFillShopping } from "react-icons/ai";
import { BiBuildingHouse, BiBath, BiCommentAdd } from "react-icons/bi";
import { BsBuilding, BsHandThumbsUp, BsHandThumbsDown } from "react-icons/bs";
import { TbToolsKitchen2, TbSofa, TbToiletPaper } from "react-icons/tb";
import { GiBrickWall } from "react-icons/gi";
import { FiRefreshCcw, FiPlusSquare } from "react-icons/fi";
import { ImEnter, ImCalendar } from "react-icons/im";
import { IoBedSharp } from "react-icons/io5";
import { MdOutlineKitchen, MdOutlineLocalOffer, MdArchitecture } from "react-icons/md";
import { FaRegHandshake } from "react-icons/fa";
import { VscKey } from "react-icons/vsc";
import { ToastContainer, toast } from 'react-toastify';
import { Link, NavLink } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from 'react-helmet';

function Contact() {
    const backgroundStyle = {
        backgroundImage: `linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)),url(${bg})`,
        height: 'calc(100vh - 70px)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
    };
    const sofaBackgroundStyle = {
        backgroundImage: `url(${sofa})`,
        minHeight: 'calc(100vh - 70px)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };

    const notify = () => toast("Message envoyé");


    const [mobilenav, setMobilenav] = useState(false)

    const [email, setEmail] = useState("");
    const [msg, setMsg] = useState("");
    const [postal, setPostal] = useState(null);
    const [surface, setSurface] = useState(0);
    const [nbEntree, setNbEntree] = useState(0);
    const [nbChambre, setNbChambre] = useState(0);
    const [nbSalon, setNbSalon] = useState(0);
    const [nbSDB, setNbSDB] = useState(0);
    const [nbSAM, setNbSAM] = useState(0);
    const [nbToilette, setNbToilette] = useState(0);
    const [nbCuisine, setNbCuisine] = useState(0);
    const [nbAutre, setNbAutre] = useState(0);
    const [detailProjet, setDetailProjet] = useState("")
    const [autreMsg, setAutreMsg] = useState("")
    const [civilite, setCivilite] = useState("")
    const [nom, setNom] = useState("")
    const [prenom, setPrenom] = useState("")
    const [telephone, setTelephone] = useState("")
    const [mail, setMail] = useState("")
    const [ou_, setOu_] = useState("")
    const [quand, setQuand] = useState("")
    const [besoin, setBesoin] = useState("")
    const [typeBien, setTypeBien] = useState("")
    const [typeProj, setTypeProj] = useState("")

    const [page1, setPage1] = useState(true);
    const [page2, setPage2] = useState(false);
    const [page3, setPage3] = useState(false);
    const [page4, setPage4] = useState(false);
    const [page5, setPage5] = useState(false);
    const [page6, setPage6] = useState(false);
    const [page7, setPage7] = useState(false);
    const [page8, setPage8] = useState(false);
    const [page9, setPage9] = useState(false);
    const [page10, setPage10] = useState(false);
    const [page11, setPage11] = useState(false);
    const [page12, setPage12] = useState(false);

    const [appartSelected, setAppartSelected] = useState(false);
    const [maisonSelected, setMaisonSelected] = useState(false);
    const [immeubleSelected, setImmeubleSelected] = useState(false);
    const [bienProfSelected, setBienProfSelected] = useState(false);

    const [rcSelected, setRcSelected] = useState(false);
    const [rcuSelected, setRcuSelected] = useState(false);
    const [rsdbSelected, setRsdbSelected] = useState(false);
    const [rsmSelected, setRsmSelected] = useState(false);

    const [offreSelected, setOffreSelected] = useState(false);
    const [compromisSelected, setCompromisSelected] = useState(false);
    const [proprietaireSelected, setProprietaireSelected] = useState(false);

    const [avantSelected, setAvantSelected] = useState(false);
    const [entreSelected, setEntreSelected] = useState(false);
    const [apresSelected, setApresSelected] = useState(false);

    const [ouiSelected, setOuiSelected] = useState(false);
    const [nonSelected, setNonSelected] = useState(false);
    const [aidejaSelected, setAidejaSelected] = useState(false);
    const currentMonth1 = new Date().getMonth() + 1 == 12 ? 0 : new Date().getMonth() + 1;
    const currentMonth2 = new Date().getMonth() + 2 == 12 ? 0 : new Date().getMonth() + 2 == 13 ? 1 : new Date().getMonth() + 2;
    const currentYear = new Date().getFullYear()

    const validCodes = ["75000, Paris"
        , "75001, Paris 1er Arrondissement"
        , "75002, Paris 2e Arrondissement"
        , "75003, Paris 3e Arrondissement"
        , "75004, Paris 4e Arrondissement"
        , "75005, Paris 5e Arrondissement"
        , "75006, Paris 6e Arrondissement"
        , "75007, Paris 7e Arrondissement"
        , "75008, Paris 8e Arrondissement"
        , "75009, Paris 9e Arrondissement"
        , "75010, Paris 10e Arrondissement"
        , "75011, Paris 11e Arrondissement"
        , "75012, Paris 12e Arrondissement"
        , "75013, Paris 13e Arrondissement"
        , "75014, Paris 14e Arrondissement"
        , "75015, Paris 15e Arrondissement"
        , "75016, Paris 16e Arrondissement"
        , "75017, Paris 17e Arrondissement"
        , "75018, Paris 18e Arrondissement"
        , "75019, Paris 19e Arrondissement"
        , "75020, Paris 20e Arrondissement"
        , "77000, Livry-sur-Seine"
        , "77000, Melun"
        , "77000, La Rochette"
        , "77000, Vaux-le-Pénil"
        , "77090, Collégien"
        , "77100, Mareuil-lès-Meaux"
        , "77100, Meaux"
        , "77100, Nanteuil-lès-Meaux"
        , "77111, Soignolles-en-Brie"
        , "77111, Solers"
        , "77114, Gouaix"
        , "77114, Hermé"
        , "77114, Noyen-sur-Seine"
        , "77114, Villiers-sur-Seine"
        , "77115, Blandy"
        , "77115, Sivry-Courtry"
        , "77118, Balloy"
        , "77118, Bazoches-lès-Bray"
        , "77118, Gravon"
        , "77120, Amillis"
        , "77120, Aulnoy"
        , "77120, Beautheil"
        , "77120, Chailly-en-Brie"
        , "77120, Coulommiers"
        , "77120, Giremoutiers"
        , "77120, Marolles-en-Brie"
        , "77120, Mauperthuis"
        , "77120, Mouroux"
        , "77120, Saints"
        , "77122, Monthyon"
        , "77123, Noisy-sur-École"
        , "77123, Tousson"
        , "77123, Le Vaudoué"
        , "77124, Crégy-lès-Meaux"
        , "77124, Chauconin-Neufmontiers"
        , "77124, Penchard"
        , "77124, Villenoy"
        , "77126, Châtenay-sur-Seine"
        , "77126, Courcelles-en-Bassée"
        , "77126, Égligny"
        , "77127, Lieusaint"
        , "77130, Barbey"
        , "77130, Cannes-Écluse"
        , "77130, Dormelles"
        , "77130, Forges"
        , "77130, La Grande-Paroisse"
        , "77130, Marolles-sur-Seine"
        , "77130, Misy-sur-Yonne"
        , "77130, Montereau-Fault-Yonne"
        , "77130, Saint-Germain-Laval"
        , "77130, La Tombe"
        , "77130, Varennes-sur-Seine"
        , "77130, Ville-Saint-Jacques"
        , "77131, Pézarches"
        , "77131, Touquin"
        , "77133, Féricy"
        , "77133, Machault"
        , "77134, Les Ormes-sur-Voulzie"
        , "77135, Pontcarré"
        , "77138, Luzancy"
        , "77139, Douy-la-Ramée"
        , "77139, Étrépilly"
        , "77139, Marcilly"
        , "77139, Puisieux"
        , "77139, Vincy-Manoeuvre"
        , "77140, Darvault"
        , "77140, Montcourt-Fromonville"
        , "77140, Nemours"
        , "77140, Nonville"
        , "77140, Saint-Pierre-lès-Nemours"
        , "77141, Vaudoy-en-Brie"
        , "77144, Chalifert"
        , "77144, Montévrain"
        , "77145, May-en-Multien"
        , "77148, Laval-en-Brie"
        , "77148, Salins"
        , "77150, Férolles-Attilly"
        , "77150, Lésigny"
        , "77151, Montceaux-lès-Provins"
        , "77154, Coutençon"
        , "77154, Villeneuve-les-Bordes"
        , "77157, Everly"
        , "77160, Chalautre-la-Petite"
        , "77160, La Chapelle-Saint-Sulpice"
        , "77160, Chenoise"
        , "77160, Cucharmoy"
        , "77160, Mortery"
        , "77160, Poigny"
        , "77160, Provins"
        , "77160, Rouilly"
        , "77160, Saint-Brice"
        , "77160, Saint-Hilliers"
        , "77160, Vulaines-lès-Provins"
        , "77163, Dammartin-sur-Tigeaux"
        , "77163, Mortcerf"
        , "77163, Tigeaux"
        , "77164, Ferrières-en-Brie"
        , "77165, Cuisy"
        , "77165, Forfry"
        , "77165, Gesvres-le-Chapitre"
        , "77165, Iverny"
        , "77165, Le Plessis-aux-Bois"
        , "77165, Le Plessis-l'Évêque"
        , "77165, Saint-Soupplets"
        , "77166, Évry-Grégy-sur-Yerre"
        , "77166, Grisy-Suisnes"
        , "77167, Bagneaux-sur-Loing"
        , "77167, Châtenoy"
        , "77167, Faÿ-lès-Nemours"
        , "77167, Ormesson"
        , "77167, Poligny"
        , "77169, Boissy-le-Châtel"
        , "77169, Chauffry"
        , "77169, Saint-Germain-sous-Doue"
        , "77169, Saint-Siméon"
        , "77170, Brie-Comte-Robert"
        , "77170, Coubert"
        , "77170, Servon"
        , "77171, Chalautre-la-Grande"
        , "77171, Léchelle"
        , "77171, Melz-sur-Seine"
        , "77171, Sourdun"
        , "77173, Chevry-Cossigny"
        , "77174, Villeneuve-le-Comte"
        , "77174, Villeneuve-Saint-Denis"
        , "77176, Nandy"
        , "77176, Savigny-le-Temple"
        , "77177, Brou-sur-Chantereine"
        , "77178, Oissery"
        , "77178, Saint-Pathus"
        , "77181, Courtry"
        , "77181, Le Pin"
        , "77183, Croissy-Beaubourg"
        , "77184, Émerainville"
        , "77185, Lognes"
        , "77186, Noisiel"
        , "77190, Dammarie-les-Lys"
        , "77190, Villiers-en-Bière"
        , "77200, Torcy"
        , "77210, Avon"
        , "77210, Samoreau"
        , "77220, Favières"
        , "77220, Gretz-Armainvilliers"
        , "77220, Liverdy-en-Brie"
        , "77220, Presles-en-Brie"
        , "77220, Tournan-en-Brie"
        , "77230, Dammartin-en-Goële"
        , "77230, Juilly"
        , "77230, Longperrier"
        , "77230, Marchémoret"
        , "77230, Montgé-en-Goële"
        , "77230, Moussy-le-Neuf"
        , "77230, Moussy-le-Vieux"
        , "77230, Nantouillet"
        , "77230, Rouvres"
        , "77230, Saint-Mard"
        , "77230, Thieux"
        , "77230, Villeneuve-sous-Dammartin"
        , "77230, Vinantes"
        , "77240, Cesson"
        , "77240, Seine-Port"
        , "77240, Vert-Saint-Denis"
        , "77250, Écuelles"
        , "77250, Épisy"
        , "77250, Montarlot"
        , "77250, Moret-sur-Loing"
        , "77250, Veneux-les-Sablons"
        , "77250, Villecerf"
        , "77250, Villemer"
        , "77260, Chamigny"
        , "77260, La Ferté-sous-Jouarre"
        , "77260, Reuil-en-Brie"
        , "77260, Sainte-Aulde"
        , "77260, Sammeron"
        , "77260, Sept-Sorts"
        , "77260, Ussy-sur-Marne"
        , "77270, Villeparisis"
        , "77280, Othis"
        , "77290, Compans"
        , "77290, Mitry-Mory"
        , "77300, Fontainebleau"
        , "77310, Boissise-le-Roi"
        , "77310, Pringy"
        , "77310, Saint-Fargeau-Ponthierry"
        , "77320, Beton-Bazoches"
        , "77320, Cerneux"
        , "77320, La Chapelle-Moutils"
        , "77320, Chartronges"
        , "77320, Chevru"
        , "77320, Choisy-en-Brie"
        , "77320, Dagny"
        , "77320, La Ferté-Gaucher"
        , "77320, Frétoy"
        , "77320, Jouy-sur-Morin"
        , "77320, Lescherolles"
        , "77320, Leudon-en-Brie"
        , "77320, Meilleray"
        , "77320, Montdauphin"
        , "77320, Montenils"
        , "77320, Montolivet"
        , "77320, Saint-Barthélemy"
        , "77320, Saint-Mars-Vieux-Maisons"
        , "77320, Saint-Martin-des-Champs"
        , "77320, Saint-Martin-du-Boschet"
        , "77320, Saint-Rémy-la-Vanne"
        , "77320, Sancy-lès-Provins"
        , "77330, Ozoir-la-Ferrière"
        , "77340, Pontault-Combault"
        , "77350, Boissettes"
        , "77350, Boissise-la-Bertrand"
        , "77350, Le Mée-sur-Seine"
        , "77360, Vaires-sur-Marne"
        , "77370, La Chapelle-Rablais"
        , "77370, Châteaubleau"
        , "77370, Clos-Fontaine"
        , "77370, La Croix-en-Brie"
        , "77370, Fontains"
        , "77370, Fontenailles"
        , "77370, Gastins"
        , "77370, Maison-Rouge"
        , "77370, Nangis"
        , "77370, Rampillon"
        , "77370, Saint-Just-en-Brie"
        , "77370, Vanvillé"
        , "77370, Vieux-Champagne"
        , "77380, Combs-la-Ville"
        , "77390, Andrezel"
        , "77390, Argentières"
        , "77390, Beauvoir"
        , "77390, Champdeuil"
        , "77390, Chaumes-en-Brie"
        , "77390, Courquetaine"
        , "77390, Courtomer"
        , "77390, Crisenoy"
        , "77390, Fouju"
        , "77390, Guignes"
        , "77390, Ozouer-le-Voulgis"
        , "77390, Verneuil-l'Étang"
        , "77390, Yèbles"
        , "77400, Carnetin"
        , "77400, Dampmart"
        , "77400, Gouvernes"
        , "77400, Lagny-sur-Marne"
        , "77400, Pomponne"
        , "77400, Saint-Thibault-des-Vignes"
        , "77400, Thorigny-sur-Marne"
        , "77410, Annet-sur-Marne"
        , "77410, Charmentray"
        , "77410, Charny"
        , "77410, Claye-Souilly"
        , "77410, Fresnes-sur-Marne"
        , "77410, Gressy"
        , "77410, Messy"
        , "77410, Précy-sur-Marne"
        , "77410, Saint-Mesmes"
        , "77410, Villeroy"
        , "77410, Villevaudé"
        , "77420, Champs-sur-Marne"
        , "77430, Champagne-sur-Seine"
        , "77440, Armentières-en-Brie"
        , "77440, Cocherel"
        , "77440, Congis-sur-Thérouanne"
        , "77440, Dhuisy"
        , "77440, Isles-les-Meldeuses"
        , "77440, Jaignes"
        , "77440, Lizy-sur-Ourcq"
        , "77440, Mary-sur-Marne"
        , "77440, Ocquerre"
        , "77440, Le Plessis-Placy"
        , "77440, Tancrou"
        , "77440, Trocy-en-Multien"
        , "77440, Vendrest"
        , "77450, Condé-Sainte-Libiaire"
        , "77450, Esbly"
        , "77450, Isles-lès-Villenoy"
        , "77450, Jablines"
        , "77450, Lesches"
        , "77450, Montry"
        , "77450, Trilbardou"
        , "77450, Vignely"
        , "77460, Chaintreaux"
        , "77460, Souppes-sur-Loing"
        , "77470, Boutigny"
        , "77470, Fublaines"
        , "77470, Montceaux-lès-Meaux"
        , "77470, Poincy"
        , "77470, Saint-Fiacre"
        , "77470, Trilport"
        , "77470, Villemareuil"
        , "77480, Baby"
        , "77480, Bray-sur-Seine"
        , "77480, Fontaine-Fourches"
        , "77480, Grisy-sur-Seine"
        , "77480, Jaulnes"
        , "77480, Montigny-le-Guesdier"
        , "77480, Mousseaux-lès-Bray"
        , "77480, Mouy-sur-Seine"
        , "77480, Passy-sur-Seine"
        , "77480, Saint-Sauveur-lès-Bray"
        , "77480, Villenauxe-la-Petite"
        , "77480, Villuis"
        , "77500, Chelles"
        , "77510, Bellot"
        , "77510, Doue"
        , "77510, Hondevilliers"
        , "77510, Rebais"
        , "77510, Sablonnières"
        , "77510, Saint-Denis-lès-Rebais"
        , "77510, Saint-Léger"
        , "77510, La Trétoire"
        , "77510, Verdelot"
        , "77510, Villeneuve-sur-Bellot"
        , "77515, La Celle-sur-Morin"
        , "77515, Faremoutiers"
        , "77515, Hautefeuille"
        , "77515, Pommeuse"
        , "77515, Saint-Augustin"
        , "77520, Cessoy-en-Montois"
        , "77520, Donnemarie-Dontilly"
        , "77520, Gurcy-le-Châtel"
        , "77520, Luisetaines"
        , "77520, Meigneux"
        , "77520, Mons-en-Montois"
        , "77520, Montigny-Lencoup"
        , "77520, Paroy"
        , "77520, Sigy"
        , "77520, Sognolles-en-Montois"
        , "77520, Thénisy"
        , "77520, Vimpelles"
        , "77540, Bernay-Vilbert"
        , "77540, La Chapelle-Iger"
        , "77540, Courpalay"
        , "77540, Lumigny-Nesles-Ormeaux"
        , "77540, Le Plessis-Feu-Aussoux"
        , "77540, Rozay-en-Brie"
        , "77540, Voinsles"
        , "77550, Limoges-Fourches"
        , "77550, Lissy"
        , "77550, Moissy-Cramayel"
        , "77550, Réau"
        , "77560, Augers-en-Brie"
        , "77560, Beauchery-Saint-Martin"
        , "77560, Champcenest"
        , "77560, Courchamp"
        , "77560, Courtacon"
        , "77560, Louan-Villegruis-Fontaine"
        , "77560, Les Marêts"
        , "77560, Rupéreux"
        , "77560, Villiers-Saint-Georges"
        , "77560, Voulton"
        , "77570, Aufferville"
        , "77570, Bougligny"
        , "77570, Château-Landon"
        , "77570, Chenou"
        , "77570, La Madeleine-sur-Loing"
        , "77570, Maisoncelles-en-Gâtinais"
        , "77570, Mondreville"
        , "77580, Bouleurs"
        , "77580, Coulommes"
        , "77580, Coutevroult"
        , "77580, Crécy-la-Chapelle"
        , "77580, Guérard"
        , "77580, La Haute-Maison"
        , "77580, Maisoncelles-en-Brie"
        , "77580, Pierre-Levée"
        , "77580, Sancy"
        , "77580, Vaucourtois"
        , "77580, Villiers-sur-Morin"
        , "77580, Voulangis"
        , "77590, Bois-le-Roi"
        , "77590, Chartrettes"
        , "77590, Fontaine-le-Port"
        , "77600, Bussy-Saint-Georges"
        , "77600, Bussy-Saint-Martin"
        , "77600, Chanteloup-en-Brie"
        , "77600, Conches-sur-Gondoire"
        , "77600, Guermantes"
        , "77600, Jossigny"
        , "77610, Les Chapelles-Bourbon"
        , "77610, Châtres"
        , "77610, Crèvecoeur-en-Brie"
        , "77610, Fontenay-Trésigny"
        , "77610, La Houssaye-en-Brie"
        , "77610, Marles-en-Brie"
        , "77610, Neufmoutiers-en-Brie"
        , "77620, Bransles"
        , "77620, Égreville"
        , "77630, Arbonne-la-Forêt"
        , "77630, Barbizon"
        , "77630, Saint-Martin-en-Bière"
        , "77640, Jouarre"
        , "77640, Signy-Signets"
        , "77650, Chalmaison"
        , "77650, Jutigny"
        , "77650, Lizines"
        , "77650, Longueville"
        , "77650, Sainte-Colombe"
        , "77650, Saint-Loup-de-Naud"
        , "77650, Savins"
        , "77650, Soisy-Bouy"
        , "77660, Changis-sur-Marne"
        , "77660, Saint-Jean-les-Deux-Jumeaux"
        , "77670, Saint-Mammès"
        , "77670, Vernou-la-Celle-sur-Seine"
        , "77680, Roissy-en-Brie"
        , "77690, La Genevraye"
        , "77690, Montigny-sur-Loing"
        , "77700, Bailly-Romainvilliers"
        , "77700, Chessy"
        , "77700, Coupvray"
        , "77700, Magny-le-Hongre"
        , "77700, Serris"
        , "77710, Chevry-en-Sereine"
        , "77710, Lorrez-le-Bocage-Préaux"
        , "77710, Nanteau-sur-Lunain"
        , "77710, Paley"
        , "77710, Remauville"
        , "77710, Saint-Ange-le-Viel"
        , "77710, Treuzy-Levelay"
        , "77710, Vaux-sur-Lunain"
        , "77710, Villebéon"
        , "77710, Villemaréchal"
        , "77720, Aubepierre-Ozouer-le-Repos"
        , "77720, Bombon"
        , "77720, Bréau"
        , "77720, Champeaux"
        , "77720, La Chapelle-Gauthier"
        , "77720, Grandpuits-Bailly-Carrois"
        , "77720, Mormant"
        , "77720, Quiers"
        , "77720, Saint-Méry"
        , "77720, Saint-Ouen-en-Brie"
        , "77730, Citry"
        , "77730, Méry-sur-Marne"
        , "77730, Nanteuil-sur-Marne"
        , "77730, Saâcy-sur-Marne"
        , "77750, Bassevelle"
        , "77750, Boitron"
        , "77750, Bussières"
        , "77750, Orly-sur-Morin"
        , "77750, Saint-Cyr-sur-Morin"
        , "77750, Saint-Ouen-sur-Morin"
        , "77760, Achères-la-Forêt"
        , "77760, Amponville"
        , "77760, Boissy-aux-Cailles"
        , "77760, Boulancourt"
        , "77760, Burcy"
        , "77760, Buthiers"
        , "77760, La Chapelle-la-Reine"
        , "77760, Chevrainvilliers"
        , "77760, Fromont"
        , "77760, Guercheville"
        , "77760, Larchant"
        , "77760, Nanteau-sur-Essonne"
        , "77760, Recloses"
        , "77760, Rumont"
        , "77760, Ury"
        , "77760, Villiers-sous-Grez"
        , "77780, Bourron-Marlotte"
        , "77810, Thomery"
        , "77820, Le Châtelet-en-Brie"
        , "77820, Châtillon-la-Borde"
        , "77820, Les Écrennes"
        , "77830, Échouboulains"
        , "77830, Pamfou"
        , "77830, Valence-en-Brie"
        , "77840, Coulombs-en-Valois"
        , "77840, Crouy-sur-Ourcq"
        , "77840, Germigny-sous-Coulombs"
        , "77850, Héricy"
        , "77860, Couilly-Pont-aux-Dames"
        , "77860, Quincy-Voisins"
        , "77860, Saint-Germain-sur-Morin"
        , "77870, Vulaines-sur-Seine"
        , "77880, Grez-sur-Loing"
        , "77890, Arville"
        , "77890, Beaumont-du-Gâtinais"
        , "77890, Garentreville"
        , "77890, Gironville"
        , "77890, Ichy"
        , "77890, Obsonville"
        , "77910, Barcy"
        , "77910, Chambry"
        , "77910, Germigny-l'Évêque"
        , "77910, Varreddes"
        , "77920, Samois-sur-Seine"
        , "77930, Cély"
        , "77930, Chailly-en-Bière"
        , "77930, Fleury-en-Bière"
        , "77930, Perthes"
        , "77930, Saint-Germain-sur-École"
        , "77930, Saint-Sauveur-sur-École"
        , "77940, Blennes"
        , "77940, La Brosse-Montceaux"
        , "77940, Diant"
        , "77940, Esmans"
        , "77940, Flagy"
        , "77940, Montmachoux"
        , "77940, Noisy-Rudignon"
        , "77940, Thoury-Férottes"
        , "77940, Voulx"
        , "77950, Maincy"
        , "77950, Moisenay"
        , "77950, Montereau-sur-le-Jard"
        , "77950, Rubelles"
        , "77950, Saint-Germain-Laxis"
        , "77950, Voisenon"
        , "77970, Bannost-Villegagnon"
        , "77970, Bezalles"
        , "77970, Boisdon"
        , "77970, Jouy-le-Châtel"
        , "77970, Pécy"
        , "77990, Mauregard"
        , "77990, Le Mesnil-Amelot"
        , "78000, Versailles"
        , "78100, Saint-Germain-en-Laye"
        , "78110, Le Vésinet"
        , "78111, Dammartin-en-Serve"
        , "78112, Fourqueux"
        , "78113, Adainville"
        , "78113, Bourdonné"
        , "78113, Condé-sur-Vesgre"
        , "78113, Grandchamp"
        , "78113, La Hauteville"
        , "78113, Le Tartre-Gaudran"
        , "78114, Magny-les-Hameaux"
        , "78117, Châteaufort"
        , "78117, Toussus-le-Noble"
        , "78120, Clairefontaine-en-Yvelines"
        , "78120, Rambouillet"
        , "78120, Sonchamp"
        , "78121, Crespières"
        , "78124, Mareil-sur-Mauldre"
        , "78124, Montainville"
        , "78125, La Boissière-École"
        , "78125, Émancé"
        , "78125, Gazeran"
        , "78125, Hermeray"
        , "78125, Mittainville"
        , "78125, Orcemont"
        , "78125, Orphin"
        , "78125, Poigny-la-Forêt"
        , "78125, Raizeux"
        , "78125, Saint-Hilarion"
        , "78125, Vieille-Église-en-Yvelines"
        , "78126, Aulnay-sur-Mauldre"
        , "78130, Chapet"
        , "78130, Les Mureaux"
        , "78140, Vélizy-Villacoublay"
        , "78150, Le Chesnay"
        , "78150, Rocquencourt"
        , "78160, Marly-le-Roi"
        , "78170, La Celle-Saint-Cloud"
        , "78180, Montigny-le-Bretonneux"
        , "78190, Trappes"
        , "78200, Boinvilliers"
        , "78200, Boissy-Mauvoisin"
        , "78200, Buchelay"
        , "78200, Favrieux"
        , "78200, Flacourt"
        , "78200, Fontenay-Mauvoisin"
        , "78200, Jouy-Mauvoisin"
        , "78200, Magnanville"
        , "78200, Mantes-la-Jolie"
        , "78200, Ménerville"
        , "78200, Perdreauville"
        , "78200, Soindres"
        , "78210, Saint-Cyr-l'École"
        , "78220, Viroflay"
        , "78230, Le Pecq"
        , "78240, Aigremont"
        , "78240, Chambourcy"
        , "78250, Gaillon-sur-Montcient"
        , "78250, Hardricourt"
        , "78250, Meulan-en-Yvelines"
        , "78250, Mézy-sur-Seine"
        , "78250, Oinville-sur-Montcient"
        , "78250, Tessancourt-sur-Aubette"
        , "78260, Achères"
        , "78270, Bennecourt"
        , "78270, Blaru"
        , "78270, Bonnières-sur-Seine"
        , "78270, Chaufour-lès-Bonnières"
        , "78270, Cravent"
        , "78270, Gommecourt"
        , "78270, Jeufosse"
        , "78270, Limetz-Villez"
        , "78270, Lommoye"
        , "78270, Méricourt"
        , "78270, Mousseaux-sur-Seine"
        , "78270, Port-Villez"
        , "78270, Rolleboise"
        , "78270, La Villeneuve-en-Chevrie"
        , "78280, Guyancourt"
        , "78290, Croissy-sur-Seine"
        , "78300, Poissy"
        , "78310, Coignières"
        , "78310, Maurepas"
        , "78320, Lévis-Saint-Nom"
        , "78320, Le Mesnil-Saint-Denis"
        , "78320, La Verrière"
        , "78330, Fontenay-le-Fleury"
        , "78340, Les Clayes-sous-Bois"
        , "78350, Jouy-en-Josas"
        , "78350, Les Loges-en-Josas"
        , "78360, Montesson"
        , "78370, Plaisir"
        , "78380, Bougival"
        , "78390, Bois-d'Arcy"
        , "78400, Chatou"
        , "78410, Aubergenville"
        , "78410, Bouafle"
        , "78410, La Falaise"
        , "78410, Flins-sur-Seine"
        , "78410, Nézel"
        , "78420, Carrières-sur-Seine"
        , "78430, Louveciennes"
        , "78440, Brueil-en-Vexin"
        , "78440, Drocourt"
        , "78440, Fontenay-Saint-Père"
        , "78440, Gargenville"
        , "78440, Guitrancourt"
        , "78440, Issou"
        , "78440, Jambville"
        , "78440, Lainville-en-Vexin"
        , "78440, Montalet-le-Bois"
        , "78440, Porcheville"
        , "78440, Sailly"
        , "78450, Chavenay"
        , "78450, Villepreux"
        , "78460, Chevreuse"
        , "78460, Choisel"
        , "78470, Milon-la-Chapelle"
        , "78470, Saint-Lambert"
        , "78470, Saint-Rémy-lès-Chevreuse"
        , "78480, Verneuil-sur-Seine"
        , "78490, Bazoches-sur-Guyonne"
        , "78490, Boissy-sans-Avoir"
        , "78490, Galluis"
        , "78490, Gambaiseuil"
        , "78490, Grosrouvre"
        , "78490, Mareil-le-Guyon"
        , "78490, Méré"
        , "78490, Les Mesnuls"
        , "78490, Montfort-l'Amaury"
        , "78490, Le Tremblay-sur-Mauldre"
        , "78490, Vicq"
        , "78500, Sartrouville"
        , "78510, Triel-sur-Seine"
        , "78520, Follainville-Dennemont"
        , "78520, Guernes"
        , "78520, Limay"
        , "78520, Saint-Martin-la-Garenne"
        , "78530, Buc"
        , "78540, Vernouillet"
        , "78550, Bazainville"
        , "78550, Dannemarie"
        , "78550, Gressey"
        , "78550, Houdan"
        , "78550, Maulette"
        , "78550, Richebourg"
        , "78560, Le Port-Marly"
        , "78570, Andrésy"
        , "78570, Chanteloup-les-Vignes"
        , "78580, Les Alluets-le-Roi"
        , "78580, Bazemont"
        , "78580, Herbeville"
        , "78580, Jumeauville"
        , "78580, Maule"
        , "78590, Noisy-le-Roi"
        , "78590, Rennemoulin"
        , "78600, Maisons-Laffitte"
        , "78600, Le Mesnil-le-Roi"
        , "78610, Auffargis"
        , "78610, Les Bréviaires"
        , "78610, Le Perray-en-Yvelines"
        , "78610, Saint-Léger-en-Yvelines"
        , "78620, L' Étang-la-Ville"
        , "78630, Morainvilliers"
        , "78630, Orgeval"
        , "78640, Neauphle-le-Château"
        , "78640, Neauphle-le-Vieux"
        , "78640, Saint-Germain-de-la-Grange"
        , "78640, Villiers-Saint-Fréderic"
        , "78650, Beynes"
        , "78650, Saulx-Marchais"
        , "78660, Ablis"
        , "78660, Allainville"
        , "78660, Boinville-le-Gaillard"
        , "78660, Orsonville"
        , "78660, Paray-Douaville"
        , "78660, Prunay-en-Yvelines"
        , "78660, Saint-Martin-de-Bréthencourt"
        , "78670, Médan"
        , "78670, Villennes-sur-Seine"
        , "78680, Épône"
        , "78690, Les Essarts-le-Roi"
        , "78690, Saint-Rémy-l'Honoré"
        , "78700, Conflans-Sainte-Honorine"
        , "78710, Rosny-sur-Seine"
        , "78711, Mantes-la-Ville"
        , "78720, La Celle-les-Bordes"
        , "78720, Cernay-la-Ville"
        , "78720, Dampierre-en-Yvelines"
        , "78720, Saint-Forget"
        , "78720, Senlisse"
        , "78730, Longvilliers"
        , "78730, Ponthévrard"
        , "78730, Rochefort-en-Yvelines"
        , "78730, Saint-Arnoult-en-Yvelines"
        , "78730, Sainte-Mesme"
        , "78740, Évecquemont"
        , "78740, Vaux-sur-Seine"
        , "78750, Mareil-Marly"
        , "78760, Jouars-Pontchartrain"
        , "78770, Andelu"
        , "78770, Auteuil"
        , "78770, Autouillet"
        , "78770, Goupillières"
        , "78770, Marcq"
        , "78770, Thoiry"
        , "78770, Villiers-le-Mahieu"
        , "78780, Maurecourt"
        , "78790, Arnouville-lès-Mantes"
        , "78790, Courgent"
        , "78790, Flins-Neuve-Église"
        , "78790, Hargeville"
        , "78790, Montchauvet"
        , "78790, Mulcent"
        , "78790, Rosay"
        , "78790, Saint-Martin-des-Champs"
        , "78790, Septeuil"
        , "78790, Tilly"
        , "78800, Houilles"
        , "78810, Davron"
        , "78810, Feucherolles"
        , "78820, Juziers"
        , "78830, Bonnelles"
        , "78830, Bullion"
        , "78840, Freneuse"
        , "78840, Moisson"
        , "78850, Thiverval-Grignon"
        , "78860, Saint-Nom-la-Bretèche"
        , "78870, Bailly"
        , "78890, Garancières"
        , "78910, Béhoust"
        , "78910, Boissets"
        , "78910, Civry-la-Forêt"
        , "78910, Flexanville"
        , "78910, Orgerus"
        , "78910, Orvilliers"
        , "78910, Osmoy"
        , "78910, Prunay-le-Temple"
        , "78910, Tacoignières"
        , "78920, Ecquevilly"
        , "78930, Auffreville-Brasseuil"
        , "78930, Boinville-en-Mantois"
        , "78930, Breuil-Bois-Robert"
        , "78930, Goussonville"
        , "78930, Guerville"
        , "78930, Vert"
        , "78930, Villette"
        , "78940, Millemont"
        , "78940, La Queue-les-Yvelines"
        , "78950, Gambais"
        , "78955, Carrières-sous-Poissy"
        , "78960, Voisins-le-Bretonneux"
        , "78970, Mézières-sur-Seine"
        , "78980, Bréval"
        , "78980, Longnes"
        , "78980, Mondreville"
        , "78980, Neauphlette"
        , "78980, Saint-Illiers-la-Ville"
        , "78980, Saint-Illiers-le-Bois"
        , "78980, Le Tertre-Saint-Denis"
        , "78990, Élancourt"
        , "91000, Évry"
        , "91070, Bondoufle"
        , "91080, Courcouronnes"
        , "91090, Lisses"
        , "91100, Corbeil-Essonnes"
        , "91100, Villabé"
        , "91120, Palaiseau"
        , "91130, Ris-Orangis"
        , "91140, Villebon-sur-Yvette"
        , "91140, Villejust"
        , "91150, Abbéville-la-Rivière"
        , "91150, Blandy"
        , "91150, Bois-Herpin"
        , "91150, Boutervilliers"
        , "91150, Brières-les-Scellés"
        , "91150, Brouy"
        , "91150, Champmotteux"
        , "91150, Étampes"
        , "91150, La Forêt-Sainte-Croix"
        , "91150, Marolles-en-Beauce"
        , "91150, Mespuits"
        , "91150, Morigny-Champigny"
        , "91150, Ormoy-la-Rivière"
        , "91150, Puiselet-le-Marais"
        , "91150, Roinvilliers"
        , "91160, Ballainvilliers"
        , "91160, Champlan"
        , "91160, Longjumeau"
        , "91160, Saulx-les-Chartreux"
        , "91170, Viry-Châtillon"
        , "91180, Saint-Germain-lès-Arpajon"
        , "91190, Gif-sur-Yvette"
        , "91190, Saint-Aubin"
        , "91190, Villiers-le-Bâcle"
        , "91200, Athis-Mons"
        , "91210, Draveil"
        , "91220, Brétigny-sur-Orge"
        , "91220, Le Plessis-Pâté"
        , "91230, Montgeron"
        , "91240, Saint-Michel-sur-Orge"
        , "91250, Morsang-sur-Seine"
        , "91250, Saint-Germain-lès-Corbeil"
        , "91250, Saintry-sur-Seine"
        , "91250, Tigery"
        , "91260, Juvisy-sur-Orge"
        , "91270, Vigneux-sur-Seine"
        , "91280, Saint-Pierre-du-Perray"
        , "91290, Arpajon"
        , "91290, La Norville"
        , "91300, Massy"
        , "91310, Leuville-sur-Orge"
        , "91310, Linas"
        , "91310, Longpont-sur-Orge"
        , "91310, Montlhéry"
        , "91320, Wissous"
        , "91330, Yerres"
        , "91340, Ollainville"
        , "91350, Grigny"
        , "91360, Épinay-sur-Orge"
        , "91360, Villemoisson-sur-Orge"
        , "91370, Verrières-le-Buisson"
        , "91380, Chilly-Mazarin"
        , "91390, Morsang-sur-Orge"
        , "91400, Gometz-la-Ville"
        , "91400, Orsay"
        , "91400, Saclay"
        , "91410, Authon-la-Plaine"
        , "91410, Chatignonville"
        , "91410, Corbreuse"
        , "91410, Dourdan"
        , "91410, La Forêt-le-Roi"
        , "91410, Les Granges-le-Roi"
        , "91410, Plessis-Saint-Benoist"
        , "91410, Richarville"
        , "91410, Roinville"
        , "91410, Saint-Cyr-sous-Dourdan"
        , "91410, Saint-Escobille"
        , "91420, Morangis"
        , "91430, Igny"
        , "91430, Vauhallan"
        , "91440, Bures-sur-Yvette"
        , "91450, Étiolles"
        , "91450, Soisy-sur-Seine"
        , "91460, Marcoussis"
        , "91470, Angervilliers"
        , "91470, Boullay-les-Troux"
        , "91470, Forges-les-Bains"
        , "91470, Limours"
        , "91470, Les Molières"
        , "91470, Pecqueuse"
        , "91480, Quincy-sous-Sénart"
        , "91480, Varennes-Jarcy"
        , "91490, Courances"
        , "91490, Dannemois"
        , "91490, Milly-la-Forêt"
        , "91490, Moigny-sur-École"
        , "91490, Oncy-sur-École"
        , "91510, Janville-sur-Juine"
        , "91510, Lardy"
        , "91520, Égly"
        , "91530, Saint-Chéron"
        , "91530, Saint-Maurice-Montcouronne"
        , "91530, Sermaise"
        , "91530, Le Val-Saint-Germain"
        , "91540, Écharcon"
        , "91540, Fontenay-le-Vicomte"
        , "91540, Mennecy"
        , "91540, Ormoy"
        , "91550, Paray-Vieille-Poste"
        , "91560, Crosne"
        , "91570, Bièvres"
        , "91580, Auvers-Saint-Georges"
        , "91580, Chauffour-lès-Étréchy"
        , "91580, Étréchy"
        , "91580, Souzy-la-Briche"
        , "91580, Villeconin"
        , "91580, Villeneuve-sur-Auvers"
        , "91590, Baulne"
        , "91590, Boissy-le-Cutté"
        , "91590, Cerny"
        , "91590, D'Huison-Longueville"
        , "91590, La Ferté-Alais"
        , "91590, Guigneville-sur-Essonne"
        , "91590, Mondeville"
        , "91590, Orveau"
        , "91600, Savigny-sur-Orge"
        , "91610, Ballancourt-sur-Essonne"
        , "91620, Nozay"
        , "91620, La Ville-du-Bois"
        , "91630, Avrainville"
        , "91630, Cheptainville"
        , "91630, Guibeville"
        , "91630, Leudeville"
        , "91630, Marolles-en-Hurepoix"
        , "91640, Briis-sous-Forges"
        , "91640, Fontenay-lès-Briis"
        , "91640, Janvry"
        , "91640, Vaugrigneuse"
        , "91650, Breuillet"
        , "91650, Breux-Jouy"
        , "91650, Saint-Yon"
        , "91660, Estouches"
        , "91660, Méréville"
        , "91670, Angerville"
        , "91680, Bruyères-le-Châtel"
        , "91680, Courson-Monteloup"
        , "91690, Arrancourt"
        , "91690, Boissy-la-Rivière"
        , "91690, Fontaine-la-Rivière"
        , "91690, Guillerval"
        , "91690, Saclas"
        , "91690, Saint-Cyr-la-Rivière"
        , "91700, Fleury-Mérogis"
        , "91700, Sainte-Geneviève-des-Bois"
        , "91700, Villiers-sur-Orge"
        , "91710, Vert-le-Petit"
        , "91720, Boigneville"
        , "91720, Buno-Bonnevaux"
        , "91720, Courdimanche-sur-Essonne"
        , "91720, Gironville-sur-Essonne"
        , "91720, Maisse"
        , "91720, Prunay-sur-Essonne"
        , "91720, Valpuiseaux"
        , "91730, Chamarande"
        , "91730, Mauchamps"
        , "91730, Torfou"
        , "91740, Chalou-Moulineux"
        , "91740, Pussay"
        , "91740, Congerville-Thionville"
        , "91750, Champcueil"
        , "91750, Chevannes"
        , "91750, Nainville-les-Roches"
        , "91760, Itteville"
        , "91770, Saint-Vrain"
        , "91780, Chalo-Saint-Mars"
        , "91780, Mérobert"
        , "91780, Saint-Hilaire"
        , "91790, Boissy-sous-Saint-Yon"
        , "91800, Boussy-Saint-Antoine"
        , "91800, Brunoy"
        , "91810, Vert-le-Grand"
        , "91820, Boutigny-sur-Essonne"
        , "91820, Vayres-sur-Essonne"
        , "91830, Auvernaux"
        , "91830, Le Coudray-Montceaux"
        , "91840, Soisy-sur-École"
        , "91850, Bouray-sur-Juine"
        , "91860, Épinay-sous-Sénart"
        , "91870, Boissy-le-Sec"
        , "91880, Bouville"
        , "91890, Videlles"
        , "91910, Saint-Sulpice-de-Favières"
        , "91930, Monnerville"
        , "91940, Gometz-le-Châtel"
        , "91940, Saint-Jean-de-Beauregard"
        , "91940, Les Ulis"
        , "92000, Nanterre"
        , "92100, Boulogne-Billancourt"
        , "92110, Clichy"
        , "92120, Montrouge"
        , "92130, Issy-les-Moulineaux"
        , "92140, Clamart"
        , "92150, Suresnes"
        , "92160, Antony"
        , "92170, Vanves"
        , "92190, Meudon"
        , "92200, Neuilly-sur-Seine"
        , "92210, Saint-Cloud"
        , "92220, Bagneux"
        , "92230, Gennevilliers"
        , "92240, Malakoff"
        , "92250, La Garenne-Colombes"
        , "92260, Fontenay-aux-Roses"
        , "92270, Bois-Colombes"
        , "92290, Châtenay-Malabry"
        , "92300, Levallois-Perret"
        , "92310, Sèvres"
        , "92320, Châtillon"
        , "92330, Sceaux"
        , "92340, Bourg-la-Reine"
        , "92350, Le Plessis-Robinson"
        , "92370, Chaville"
        , "92380, Garches"
        , "92390, Villeneuve-la-Garenne"
        , "92400, Courbevoie"
        , "92410, Ville-d'Avray"
        , "92420, Vaucresson"
        , "92430, Marnes-la-Coquette"
        , "92500, Rueil-Malmaison"
        , "92600, Asnières-sur-Seine"
        , "92700, Colombes"
        , "92800, Puteaux"
        , "93000, Bobigny"
        , "93100, Montreuil"
        , "93110, Rosny-sous-Bois"
        , "93120, La Courneuve"
        , "93130, Noisy-le-Sec"
        , "93140, Bondy"
        , "93150, Le Blanc-Mesnil"
        , "93160, Noisy-le-Grand"
        , "93170, Bagnolet"
        , "93190, Livry-Gargan"
        , "93200, Saint-Denis"
        , "93220, Gagny"
        , "93230, Romainville"
        , "93240, Stains"
        , "93250, Villemomble"
        , "93260, Les Lilas"
        , "93270, Sevran"
        , "93290, Tremblay-en-France"
        , "93300, Aubervilliers"
        , "93310, Le Pré-Saint-Gervais"
        , "93320, Les Pavillons-sous-Bois"
        , "93330, Neuilly-sur-Marne"
        , "93340, Le Raincy"
        , "93350, Le Bourget"
        , "93360, Neuilly-Plaisance"
        , "93370, Montfermeil"
        , "93380, Pierrefitte-sur-Seine"
        , "93390, Clichy-sous-Bois"
        , "93400, Saint-Ouen"
        , "93410, Vaujours"
        , "93420, Villepinte"
        , "93430, Villetaneuse"
        , "93440, Dugny"
        , "93450, L' Île-Saint-Denis"
        , "93460, Gournay-sur-Marne"
        , "93470, Coubron"
        , "93500, Pantin"
        , "93600, Aulnay-sous-Bois"
        , "93700, Drancy"
        , "93800, Épinay-sur-Seine"
        , "94000, Créteil"
        , "94100, Saint-Maur-des-Fossés"
        , "94110, Arcueil"
        , "94120, Fontenay-sous-Bois"
        , "94130, Nogent-sur-Marne"
        , "94140, Alfortville"
        , "94150, Rungis"
        , "94160, Saint-Mandé"
        , "94170, Le Perreux-sur-Marne"
        , "94190, Villeneuve-Saint-Georges"
        , "94200, Ivry-sur-Seine"
        , "94220, Charenton-le-Pont"
        , "94230, Cachan"
        , "94240, L' Haÿ-les-Roses"
        , "94250, Gentilly"
        , "94260, Fresnes"
        , "94270, Le Kremlin-Bicêtre"
        , "94290, Villeneuve-le-Roi"
        , "94300, Vincennes"
        , "94310, Orly"
        , "94320, Thiais"
        , "94340, Joinville-le-Pont"
        , "94350, Villiers-sur-Marne"
        , "94360, Bry-sur-Marne"
        , "94370, Sucy-en-Brie"
        , "94380, Bonneuil-sur-Marne"
        , "94400, Vitry-sur-Seine"
        , "94410, Saint-Maurice"
        , "94420, Le Plessis-Trévise"
        , "94430, Chennevières-sur-Marne"
        , "94440, Marolles-en-Brie"
        , "94440, Santeny"
        , "94440, Villecresnes"
        , "94450, Limeil-Brévannes"
        , "94460, Valenton"
        , "94470, Boissy-Saint-Léger"
        , "94480, Ablon-sur-Seine"
        , "94490, Ormesson-sur-Marne"
        , "94500, Champigny-sur-Marne"
        , "94510, La Queue-en-Brie"
        , "94520, Mandres-les-Roses"
        , "94520, Périgny"
        , "94550, Chevilly-Larue"
        , "94600, Choisy-le-Roi"
        , "94700, Maisons-Alfort"
        , "94800, Villejuif"
        , "94880, Noiseau"
        , "95000, Boisemont"
        , "95000, Cergy"
        , "95000, Neuville-sur-Oise"
        , "95000, Pontoise"
        , "95100, Argenteuil"
        , "95110, Sannois"
        , "95120, Ermont"
        , "95130, Franconville"
        , "95130, Le Plessis-Bouchard"
        , "95140, Garges-lès-Gonesse"
        , "95150, Taverny"
        , "95160, Montmorency"
        , "95170, Deuil-la-Barre"
        , "95180, Menucourt"
        , "95190, Châtenay-en-France"
        , "95190, Fontenay-en-Parisis"
        , "95190, Goussainville"
        , "95200, Sarcelles"
        , "95210, Saint-Gratien"
        , "95220, Herblay"
        , "95230, Soisy-sous-Montmorency"
        , "95240, Cormeilles-en-Parisis"
        , "95250, Beauchamp"
        , "95260, Beaumont-sur-Oise"
        , "95260, Mours"
        , "95270, Asnières-sur-Oise"
        , "95270, Bellefontaine"
        , "95270, Belloy-en-France"
        , "95270, Chaumontel"
        , "95270, Épinay-Champlâtreux"
        , "95270, Lassy"
        , "95270, Luzarches"
        , "95270, Noisy-sur-Oise"
        , "95270, Le Plessis-Luzarches"
        , "95270, Saint-Martin-du-Tertre"
        , "95270, Seugy"
        , "95270, Viarmes"
        , "95280, Jouy-le-Moutier"
        , "95290, L' Isle-Adam"
        , "95300, Ennery"
        , "95300, Hérouville"
        , "95300, Livilliers"
        , "95310, Saint-Ouen-l'Aumône"
        , "95320, Saint-Leu-la-Forêt"
        , "95330, Domont"
        , "95340, Bernes-sur-Oise"
        , "95340, Persan"
        , "95340, Ronquerolles"
        , "95350, Piscop"
        , "95350, Saint-Brice-sous-Forêt"
        , "95360, Montmagny"
        , "95370, Montigny-lès-Cormeilles"
        , "95380, Chennevières-lès-Louvres"
        , "95380, Épiais-lès-Louvres"
        , "95380, Louvres"
        , "95380, Puiseux-en-France"
        , "95380, Villeron"
        , "95390, Saint-Prix"
        , "95400, Arnouville"
        , "95400, Villiers-le-Bel"
        , "95410, Groslay"
        , "95420, Arthies"
        , "95420, Banthelu"
        , "95420, La Chapelle-en-Vexin"
        , "95420, Charmont"
        , "95420, Cléry-en-Vexin"
        , "95420, Genainville"
        , "95420, Hodent"
        , "95420, Magny-en-Vexin"
        , "95420, Maudétour-en-Vexin"
        , "95420, Nucourt"
        , "95420, Omerville"
        , "95420, Saint-Gervais"
        , "95420, Wy-dit-Joli-Village"
        , "95430, Auvers-sur-Oise"
        , "95430, Butry-sur-Oise"
        , "95430, 95440, Écouen"
        , "95430, 95450, Ableiges"
        , "95430, Avernes"
        , "95430, Commeny"
        , "95430, Condécourt"
        , "95430, Frémainville"
        , "95430, Gadancourt"
        , "95430, Gouzangrez"
        , "95430, Guiry-en-Vexin"
        , "95430, Longuesse"
        , "95430, Le Perchay"
        , "95430, Sagy"
        , "95430, Seraincourt"
        , "95430, Théméricourt"
        , "95430, Us"
        , "95430, Vigny"
        , "95460, Ézanville"
        , "95470, Fosses"
        , "95470, Saint-Witz"
        , "95470, Survilliers"
        , "95470, Vémars"
        , "95480, Pierrelaye"
        , "95490, Vauréal"
        , "95500, Bonneuil-en-France"
        , "95500, Gonesse"
        , "95500, Le Thillay"
        , "95500, Vaudherland"
        , "95510, Aincourt"
        , "95510, Amenucourt"
        , "95510, Chérence"
        , "95510, Saint-Cyr-en-Arthies"
        , "95510, Vétheuil"
        , "95510, Vienne-en-Arthies"
        , "95510, Villers-en-Arthies"
        , "95520, Osny"
        , "95530, La Frette-sur-Seine"
        , "95540, Méry-sur-Oise"
        , "95550, Bessancourt"
        , "95560, Baillet-en-France"
        , "95560, Chauvry"
        , "95560, Maffliers"
        , "95560, Montsoult"
        , "95570, Attainville"
        , "95570, Bouffémont"
        , "95570, Moisselles"
        , "95570, Villaines-sous-Bois"
        , "95580, Andilly"
        , "95580, Margency"
        , "95590, Nerville-la-Forêt"
        , "95590, Nointel"
        , "95590, Presles"
        , "95600, Eaubonne"
        , "95610, Éragny"
        , "95620, Parmain"
        , "95630, Mériel"
        , "95640, Bréançon"
        , "95640, Brignancourt"
        , "95640, Haravilliers"
        , "95640, Le Heaulme"
        , "95640, Marines"
        , "95640, Moussy"
        , "95640, Neuilly-en-Vexin"
        , "95640, Santeuil"
        , "95650, Boissy-l'Aillerie"
        , "95650, Courcelles-sur-Viosne"
        , "95650, Génicourt"
        , "95650, Montgeroult"
        , "95650, Puiseux-Pontoise"
        , "95660, Champagne-sur-Oise"
        , "95670, Marly-la-Ville"
        , "95680, Montlignon"
        , "95690, Frouville"
        , "95690, Hédouville"
        , "95690, Labbeville"
        , "95690, Nesles-la-Vallée"
        , "95700, Roissy-en-France"
        , "95710, Ambleville"
        , "95710, Bray-et-Lû"
        , "95710, Chaussy"
        , "95720, Bouqueval"
        , "95720, Le Mesnil-Aubry"
        , "95720, Le Plessis-Gassot"
        , "95720, Villiers-le-Sec"
        , "95740, Frépillon"
        , "95750, Le Bellay-en-Vexin"
        , "95750, Chars"
        , "95760, Valmondois"
        , "95770, Buhy"
        , "95770, Montreuil-sur-Epte"
        , "95770, Saint-Clair-sur-Epte"
        , "95780, Haute-Isle"
        , "95780, La Roche-Guyon"
        , "95800, Courdimanche"
        , "95810, Arronville"
        , "95810, Berville"
        , "95810, Épiais-Rhus"
        , "95810, Grisy-les-Plâtres"
        , "95810, Menouville"
        , "95810, Theuville"
        , "95810, Vallangoujard"
        , "95820, Bruyères-sur-Oise"
        , "95830, Cormeilles-en-Vexin"
        , "95830, Frémécourt"
        , "95840, Béthemont-la-Forêt"
        , "95840, Villiers-Adam"
        , "95850, Jagny-sous-Bois"
        , "95850, Mareil-en-France"
        , "95870, Bezons"
        , "95880, Enghien-les-Bains"]

    console.log("Month ", currentMonth2)

    const monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
        "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Decembre"
    ];
    const mailto = "mailto:renovation@decohome75.fr?subject=Devis en ligne: " + nom + " " + prenom + "&body=Nom: " + nom + " " + prenom + "%0D%0AEmail: " + mail + "%0D%0ATelephone: " + telephone + "%0D%0AType projet: " + typeProj + "%0D%0APostal: " + postal + "%0D%0ASurface: " + surface + "%0D%0AEntrée: " + nbEntree + "%0D%0AChambre: " + nbChambre + "%0D%0ASalon: " + nbSalon + "%0D%0ASalle de bain: " + nbSDB + "%0D%0ASalle à manger: " + nbSAM + "%0D%0AToilette: " + nbToilette + "%0D%0ACuisine: " + nbCuisine + "%0D%0AAutre: " + nbAutre + "%0D%0AOù en êtes-vous dans votre projet?: " + ou_ + "%0D%0AQuand souhaiteriez-vous commencer les travaux ?: " + quand + "%0D%0APensez-vous avoir besoin d'un architecte ?: " + besoin + "%0D%0AAuriez-vous quelque chose à ajouter ?: " + autreMsg + "%0D%0AVoulez-vous décrire plus en détail votre projet ?: " + detailProjet;


    const switchView = (index) => {
        if (index === 1) { //Continuer 1
            setPage1(false);
            setPage2(true);
        } else if (index === 2) { //Precedent 2
            setPage1(true);
            setPage2(false);
        }
        else if (index === 3) { //Continuer 2
            setPage2(false);
            setPage3(true);
        }
        else if (index === 4) { //Precedent 3
            setPage2(true);
            setPage3(false);
        }
        else if (index === 5) { //Continuer 3
            setPage4(true);
            setPage3(false);
        }
        else if (index === 6) { //Precedent 4
            setPage4(false);
            setPage3(true);
        }
        else if (index === 7) { //Continuer 4
            setPage5(true);
            setPage4(false);
        }
        else if (index === 8) { //Precedent 5
            setPage6(false);
            setPage5(false);
            setPage4(true);
        }
        else if (index === 9) { //Continuer 5
            setPage6(true);
            setPage5(false);
            setPage4(false);
        }
        else if (index === 10) { //Precedent 6
            setPage6(false);
            setPage5(true);
        }
        else if (index === 11) { //Continuer 6
            setPage7(true);
            setPage6(false);
        }
        else if (index === 12) { //Precedent 7
            setPage7(false);
            setPage6(true);
        }
        else if (index === 13) { //Continuer 7
            setPage8(true);
            setPage7(false);
        }
        else if (index === 14) { //Precedent 8
            setPage8(false);
            setPage7(true);
        }
        else if (index === 15) { //Continuer 8
            setPage9(true);
            setPage8(false);
        }
        else if (index === 16) { //Precedent 9
            setPage9(false);
            setPage8(true);
        }
        else if (index === 17) { //Continuer 9
            setPage10(true);
            setPage9(false);
        }
        else if (index === 18) { //Precedent 10
            setPage10(false);
            setPage9(true);
        }
        else if (index === 19) { //Continuer 10
            setPage11(true);
            setPage10(false);
        }
        else if (index === 20) { //Precedent 11
            setPage11(false);
            setPage10(true);
        }
        else if (index === 21) { //Continuer 11
            setPage12(true);
            setPage11(false);
        }
        else if (index === 22) { //Precedent 12
            setPage12(false);
            setPage11(true)
        }
    }

    const clearData = () => {
        setNbEntree(0)
        setNbChambre(0)
        setNbAutre(0)
        setNbCuisine(0)
        setNbSAM(0)
        setNbSDB(0)
        setNbSalon(0)
        setNbToilette(0)
    }

    const clearAll = () => {
        setNbEntree(0);
        setNbChambre(0);
        setNbAutre(0);
        setNbCuisine(0);
        setNbSAM(0);
        setNbSDB(0);
        setNbSalon(0);
        setNbToilette(0);
        setPostal(null);
        setSurface(null);
        setDetailProjet("");
        setAutreMsg("");
        setCivilite("");
        setNom("");
        setPrenom("");
        setTelephone("");
        setMail("");
        setOu_("");
        setQuand("");
        setBesoin("");
        setTypeBien("");
        setTypeProj("");

        setAppartSelected(false);
        setMaisonSelected(false);
        setImmeubleSelected(false);
        setBienProfSelected(false);

        setRcSelected(false);
        setRcuSelected(false);
        setRsdbSelected(false);
        setRsmSelected(false);

        setOffreSelected(false);
        setCompromisSelected(false);
        setProprietaireSelected(false);

        setAvantSelected(false);
        setEntreSelected(false);
        setApresSelected(false);

        setOuiSelected(false);
        setNonSelected(false);
        setAidejaSelected(false);
    }


    const validateFields = () => {

        const telephoneRegex = /^(\+[0-9]{0,1})?[0-9]*$/;

        if (!mail.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
            toast.error("Mauvais format d'email")
        }
        else {
        }
        if (!telephoneRegex.test(telephone) || telephone.length < 5) {
            toast.error("Mauvais format du telephone")
        }else{
        }
        if (mail.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) && telephoneRegex.test(telephone) && telephone.length >= 5) {
            sendMessageApi(); clearAll(); switchView(2); window.location.href = mailto
        }
    }

    const sendMessageApi = () => {

        var formData = new FormData();
        formData.append("nom", nom);
        formData.append("email", mail);
        formData.append("postal", postal);
        formData.append("typeBien", typeBien);
        formData.append("typeProj", typeProj);
        formData.append("entree", nbEntree);
        formData.append("chambre", nbChambre);
        formData.append("salon", nbSalon);
        formData.append("sdb", nbSDB);
        formData.append("sam", nbSAM);
        formData.append("toilette", nbToilette);
        formData.append("cuisine", nbCuisine);
        formData.append("autre", nbAutre);
        formData.append("surface", surface);
        formData.append("ou_", ou_);
        formData.append("quand", quand);
        formData.append("besoin", besoin);
        formData.append("autre_msg", autreMsg);
        formData.append("detail_msg", detailProjet);
        formData.append("civilite", civilite);
        formData.append("prenom", prenom);
        formData.append("telephone", telephone);
        console.log("From Data", formData)
        Axios.post(apiUrl + 'sendMessage.php', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(response => console.log("RESPONSEEEE", response), notify())
            .catch(error => console.log("ERRORR", error));
    }

    function topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 992) {
                setMobilenav(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);

    }, [window.innerWidth]);

    return (
        <div>
            <Helmet>
                <title>Décohome75 - Devis Et Contact</title>
      <meta name="description" content="Décohome75 est une entreprise de rénovation intégrale pour maison basée à Paris, France, spécialisée dans les rénovations de salle de bain, cuisine, murs et sols. Nous proposons des services de maçonnerie, plomberie, menuiserie, peinture et plâtrerie, électricité générale, parqueterie et carrelage." />
        <meta name="keywords" content="rénovation, maison, rénovation intégrale, rénovation complète, salle de bain, cuisine, murs et sols, maçonnerie, plomberie, menuiserie, peinture et plâtrerie, électricité générale, parqueterie, carrelage" />
        <meta name="robots" content="index, follow" />
      </Helmet>
            <ToastContainer
                autoClose={2000}
                hideProgressBar={true} />

            {/* navbar */}

            <div class="home-navbar">
                <div class="container mynavbar-container" >
                    <div class="">
                        <Link
                            to="/"
                            className="my-navbar-logo"
                            onClick={() => topFunction()}
                        ><img src="../assets/images/logo-dark.png" alt="" /></Link>
                    </div>
                    <div className='mynvabar-links'>
                        <NavLink
                            to="/entreprise"
                            id="entreprise"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Qui sommes-nous
                        </NavLink>
                        <NavLink
                            to="/competence"
                            id="competence"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Compétences
                        </NavLink>
                        <NavLink
                            to="/realisation"
                            id="realisation"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Nos Réalisations
                        </NavLink>
                        <NavLink
                            to="/contact"
                            id="contact"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Devis et Contact
                        </NavLink>

                    </div>
                    <div className='mynavbar-icon' onClick={() => { setMobilenav(!mobilenav) }}>
                        <i class="fa fa-bars" aria-hidden="true"></i>
                    </div>
                </div>
                <div className={`mynavbar-mobile-container ${mobilenav ? "mynavbar-mobile-container-visible" : ""}`}>
                    <div className='container mynavbar-links-mobile noPadding'>
                        <NavLink
                            to="/entreprise"
                            id="entreprise"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Qui sommes-nous
                        </NavLink>
                        <NavLink
                            to="/competence"
                            id="competence"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Compétences
                        </NavLink>
                        <NavLink
                            to="/realisation"
                            id="realisation"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Nos Réalisations
                        </NavLink>
                        <NavLink
                            to="/contact"
                            id="contact"
                            className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                            onClick={() => topFunction()}
                        >
                            Devis et Contact
                        </NavLink>
                    </div>
                </div>
            </div>
            {page1 === true ? (

                <div class="contact-banner-area" style={backgroundStyle}>
                    <div>
                        <img src={require("../img/logo-devis.png")} class="" width="300" height="auto" alt="" />
                        <h2 class=" home-banner-title" >
                            Construisons votre demande de devis ensemble
                        </h2>
                        <div class="local-scroll ">

                            <div onClick={() => switchView(1)} class="contact-red-button">
                                Continuer
                            </div>
                        </div>
                    </div>

                </div>


            ) : page2 === true ? (
                <div class="" style={sofaBackgroundStyle}>
                    <div class="container pagesContainer">
                        <div class="page3TitleContainer">
                            <div class="text-red page3Title">Nous aurions besoin du code postal de votre chantier</div>
                        </div>
                        <div class="page2ItemsContainer noPadding">
                            <div class="page2Item">
                                <input class="" list="CodePostal_IDF" name="Code_Postal" placeholder="Exemple: 75001" value={postal} onChange={(event) => setPostal(event.target.value)} />
                                <datalist id="CodePostal_IDF">
                                    {validCodes.map((code) => (
                                        <option key={code} value={code}>
                                            {code}
                                        </option>
                                    ))}
                                </datalist>

                            </div>
                            <div class="page2ImageContainer">
                                <img src={require("../img/MicrosoftTeams-image.png")} width="300" height="auto" alt="" />
                            </div>
                        </div>
                        <div class="page3ButtonsContainer">
                            <div className="cursor-pointer contact-buttons d-flex align-items-center justify-content-center" onClick={() => switchView(2)}>
                                <i class="fa fa-arrow-left" ></i> <div className='ps-2'>Précédent</div> 
                            </div>
                            <div className="cursor-pointer contact-buttons d-flex align-items-center justify-content-center" disabled={!validCodes.includes(postal)} onClick={() => switchView(3)}>
                                 <div className='pe-2'>Continuer</div> <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            ) : page3 === true ? (
                <div class="" style={sofaBackgroundStyle}>
                    <div className='container pagesContainer'>
                        <div class="page3TitleContainer">
                            <div class="text-red page3Title">Le type de votre bien</div>
                        </div>
                        <div class="page3ItemContainer">

                            <div class={`page3Item contact-red-button-transparent ${appartSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setAppartSelected(!appartSelected); setMaisonSelected(false); setImmeubleSelected(false); setBienProfSelected(false); setTypeBien("Appartement") }}>
                                    <DevisToggleItemsType1 title="Appartement" icon={<BiBuildingHouse class="devisIcon-1" />} />
                                </a>
                            </div>

                            <div class={`page3Item contact-red-button-transparent ${maisonSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setAppartSelected(false); setMaisonSelected(!maisonSelected); setImmeubleSelected(false); setBienProfSelected(false); setTypeBien("Maison") }}>
                                    <DevisToggleItemsType1 title="Maison" icon={<AiFillHome class="devisIcon-1" />} />
                                </a>

                            </div>
                            <div class={`page3Item contact-red-button-transparent ${immeubleSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setAppartSelected(false); setMaisonSelected(false); setImmeubleSelected(!immeubleSelected); setBienProfSelected(false); setTypeBien("Immeuble") }}>
                                    <DevisToggleItemsType1 title="Immeuble" icon={<BsBuilding class="devisIcon-1" />} />
                                </a>

                            </div>
                            <div class={`page3Item contact-red-button-transparent ${bienProfSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setAppartSelected(false); setMaisonSelected(false); setImmeubleSelected(false); setBienProfSelected(!bienProfSelected); setTypeBien("Bien professionnel") }}>
                                    <DevisToggleItemsType1 title="Bien professionnel" icon={<AiFillShopping class="devisIcon-1" />} />
                                </a>

                            </div>

                        </div>
                        <div class="page3ButtonsContainer">
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" onClick={() => switchView(4)}>
                                <i class="fa fa-arrow-left" ></i> <div className='ps-2'>Précédent</div>
                            </div>
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" disabled={appartSelected === false && maisonSelected === false && immeubleSelected === false && bienProfSelected === false} onClick={() => switchView(5)}>
                                <div className='pe-2'>Continuer</div> <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            ) : page4 === true ? (
                <div class="" style={sofaBackgroundStyle}>
                    <div className='container pagesContainer'>
                        <div class="page3TitleContainer">
                            <div class="text-red page3Title">Le type de projet que vous souhaiteriez réaliser</div>
                        </div>
                        <div class="page3ItemContainer">

                            <div class={`page3Item contact-red-button-transparent ${rcSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setRcSelected(!rcSelected); setRcuSelected(false); setRsdbSelected(false); setRsmSelected(false); setTypeProj("Rénovation complète"); clearData() }}>
                                    <DevisToggleItemsType1 title="Rénovation complète" icon={<FiRefreshCcw class="devisIcon-1" />} />
                                </a>
                            </div>

                            <div class={`page3Item contact-red-button-transparent ${rcuSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setRcuSelected(!rcuSelected); setRcSelected(false); setRsdbSelected(false); setRsmSelected(false); setTypeProj("Rénovation cuisine"); clearData() }}>
                                    <DevisToggleItemsType1 title="Rénovation cuisine" icon={<TbToolsKitchen2 class="devisIcon-1" />} />
                                </a>

                            </div>
                            <div class={`page3Item contact-red-button-transparent ${rsdbSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setRsdbSelected(!rsdbSelected); setRcSelected(false); setRcuSelected(false); setRsmSelected(false); setTypeProj("Rénovation salle de bain"); clearData() }}>
                                    <DevisToggleItemsType1 title="Rénovation salle de bain" icon={<BiBath class="devisIcon-1" />} />
                                </a>

                            </div>
                            <div class={`page3Item contact-red-button-transparent ${rsmSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setRsmSelected(!rsmSelected); setRcSelected(false); setRcuSelected(false); setRsdbSelected(false); setTypeProj("Rénovation sols et murs"); clearData() }}>
                                    <DevisToggleItemsType1 title="Rénovation sols et murs" icon={<GiBrickWall class="devisIcon-1" />} />
                                </a>

                            </div>

                        </div>
                        <div class="page3ButtonsContainer">
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" onClick={() => switchView(6)}>
                                <i class="fa fa-arrow-left" ></i> <div className='ps-2'>Précédent</div>
                            </div>
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" disabled={rcSelected === false && rcuSelected === false && rsdbSelected === false && rsmSelected === false} onClick={() => { rcuSelected === true ? switchView(9) : switchView(7) }}>
                                <div className='pe-2'>Continuer</div> <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            ) : page5 === true ? (
                <div class="" style={sofaBackgroundStyle}>

                    <div className='container pagesContainer'>
                        <div class="page3TitleContainer">
                            <div class="text-red page3Title">Les pièces que vous souhaiteriez rénover</div>
                        </div>
                        <div>
                            {rsdbSelected === true ? (
                                <div className='page5ItemsContainer'>
                                    <div class="PlusMinus-div page5Item" >
                                        <div class="">
                                            <BiBath class="devisIconSmall" />
                                        </div>
                                        <div class=" bodyPiecesDevis">
                                            Salle de bain
                                        </div>
                                        <div class="contact-inc-dec-container noPadding"><button class="transp" onClick={() => { nbSDB > 0 ? setNbSDB(nbSDB - 1) : setNbSDB(0) }}>-</button>&nbsp;<span>{nbSDB}</span>&nbsp;<button class="transp" onClick={() => setNbSDB(nbSDB + 1)}>+</button></div>
                                    </div>
                                    <div class="PlusMinus-div page5Item">
                                        <div class="">
                                            <TbToiletPaper class="devisIconSmall" />
                                        </div>
                                        <div class=" bodyPiecesDevis">
                                            Toilette
                                        </div>
                                        <div class="contact-inc-dec-container noPadding"><button class="transp" onClick={() => { nbToilette > 0 ? setNbToilette(nbToilette - 1) : setNbToilette(0) }}>-</button>&nbsp;<span>{nbToilette}</span>&nbsp;<button class="transp" onClick={() => setNbToilette(nbToilette + 1)}>+</button></div>
                                    </div>
                                </div>
                            ) :
                                <div className='page5ItemsContainer'>
                                    <div>
                                        <div class="PlusMinus-div page5Item" >
                                            <div class="">
                                                <ImEnter class="devisIconSmall" />
                                            </div>
                                            <div class="bodyPiecesDevis">
                                                Entrée
                                            </div>
                                            <div class="noPadding contact-inc-dec-container"><button class="transp" onClick={() => { nbEntree > 0 ? setNbEntree(nbEntree - 1) : setNbEntree(0) }}>-</button>&nbsp;<span>{nbEntree}</span>&nbsp;<button class="transp" onClick={() => setNbEntree(nbEntree + 1)}>+</button></div>
                                        </div>
                                        <div class="PlusMinus-div page5Item " >
                                            <div class="">
                                                <IoBedSharp class="devisIconSmall" />
                                            </div>
                                            <div class="bodyPiecesDevis">
                                                Chambre
                                            </div>
                                            <div class="noPadding contact-inc-dec-container"><button class="transp" onClick={() => { nbChambre > 0 ? setNbChambre(nbChambre - 1) : setNbChambre(0) }}>-</button>&nbsp;<span>{nbChambre}</span>&nbsp;<button class="transp" onClick={() => setNbChambre(nbChambre + 1)}>+</button></div>
                                        </div>
                                        <div class="PlusMinus-div page5Item" >
                                            <div class="">
                                                <TbSofa class="devisIconSmall" />
                                            </div>
                                            <div class="bodyPiecesDevis">
                                                Salon
                                            </div>
                                            <div class="noPadding contact-inc-dec-container"><button class="transp" onClick={() => { nbSalon > 0 ? setNbSalon(nbSalon - 1) : setNbSalon(0) }}>-</button>&nbsp;<span>{nbSalon}</span>&nbsp;<button class="transp" onClick={() => setNbSalon(nbSalon + 1)}>+</button></div>
                                        </div>
                                        <div class="PlusMinus-div page5Item " >
                                            <div class="">
                                                <BiBath class="devisIconSmall" />
                                            </div>
                                            <div class="bodyPiecesDevis">
                                                Salle de bain
                                            </div>
                                            <div class="noPadding contact-inc-dec-container"><button class="transp" onClick={() => { nbSDB > 0 ? setNbSDB(nbSDB - 1) : setNbSDB(0) }}>-</button>&nbsp;<span>{nbSDB}</span>&nbsp;<button class="transp" onClick={() => setNbSDB(nbSDB + 1)}>+</button></div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="PlusMinus-div page5Item " >
                                            <div class="">
                                                <TbToolsKitchen2 class="devisIconSmall" />
                                            </div>
                                            <div class="bodyPiecesDevis">
                                                Salle à manger
                                            </div>
                                            <div class="noPadding contact-inc-dec-container"><button class="transp" onClick={() => { nbSAM > 0 ? setNbSAM(nbSAM - 1) : setNbSAM(0) }}>-</button>&nbsp;<span>{nbSAM}</span>&nbsp;<button class="transp" onClick={() => setNbSAM(nbSAM + 1)}>+</button></div>
                                        </div>
                                        <div class="PlusMinus-div page5Item " >
                                            <div class="">
                                                <TbToiletPaper class="devisIconSmall" />
                                            </div>
                                            <div class="bodyPiecesDevis">
                                                Toilette
                                            </div>
                                            <div class="noPadding contact-inc-dec-container"><button class="transp" onClick={() => { nbToilette > 0 ? setNbToilette(nbToilette - 1) : setNbToilette(0) }}>-</button>&nbsp;<span>{nbToilette}</span>&nbsp;<button class="transp" onClick={() => setNbToilette(nbToilette + 1)}>+</button></div>
                                        </div>
                                        <div class="PlusMinus-div page5Item " >
                                            <div class="">
                                                <MdOutlineKitchen class="devisIconSmall" />
                                            </div>
                                            <div class="bodyPiecesDevis">
                                                Cuisine
                                            </div>
                                            <div class="noPadding contact-inc-dec-container"><button class="transp" onClick={() => { nbCuisine > 0 ? setNbCuisine(nbCuisine - 1) : setNbCuisine(0) }}>-</button>&nbsp;<span>{nbCuisine}</span>&nbsp;<button class="transp" onClick={() => setNbCuisine(nbCuisine + 1)}>+</button></div>
                                        </div>
                                        <div class="PlusMinus-div page5Item " >
                                            <div class="">
                                                <FiPlusSquare class="devisIconSmall" />
                                            </div>
                                            <div class="bodyPiecesDevis">
                                                Autre
                                            </div>
                                            <div class="noPadding contact-inc-dec-container"><button class="transp" onClick={() => { nbAutre > 0 ? setNbAutre(nbAutre - 1) : setNbAutre(0) }}>-</button>&nbsp;<span>{nbAutre}</span>&nbsp;<button class="transp" onClick={() => setNbAutre(nbAutre + 1)}>+</button></div>
                                        </div>
                                    </div>
                                </div>
                            }

                        </div>
                        <div class="page3ButtonsContainer">
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" onClick={() => switchView(8)}>
                                <i class="fa fa-arrow-left" ></i> <div className='ps-2'>Précédent</div>
                            </div>
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" onClick={() => switchView(9)}>
                                <div className='pe-2'>Continuer</div> <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            ) : page6 === true ? (
                <div class="" style={sofaBackgroundStyle}>
                    <div className='container pagesContainer'>
                        <div class="page3TitleContainer">
                            <div class="text-red page3Title">La surface à rénover en m²</div>
                        </div>
                        <div class="page6ItemsContainer">
                            <input type="text" class="" placeholder='Exemple: 27' value={surface} onChange={(e) => {
                                const newValue = e.target.value;
                                if(newValue === "" || /^\d+$/.test(newValue)) {
                                    setSurface(newValue);
                                  }
                            }} />
                        </div>
                        <div class="page3ButtonsContainer">
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" onClick={() => { rcuSelected === true ? switchView(8) : switchView(10) }}>
                                <i class="fa fa-arrow-left" ></i> <div className='ps-2'>Précédent</div>
                            </div>
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" disabled={!surface} onClick={() => switchView(11)}>
                                <div className='pe-2'>Continuer</div> <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            ) : page7 === true ? (
                <div class="" style={sofaBackgroundStyle}>
                    <div className='container pagesContainer'>
                        <div class="page3TitleContainer">
                            <div class="text-red page3Title">Où en êtes-vous dans votre projet?</div>
                        </div>
                        <div class="page7ItemContainer">
                            <div class={`page7Item contact-red-button-transparent ${offreSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setOffreSelected(!offreSelected); setCompromisSelected(false); setProprietaireSelected(false); setOu_("J'ai fait une offre") }}>
                                    <DevisToggleItemsType1 title="J'ai fait une offre" icon={<MdOutlineLocalOffer class="devisIcon-1" />} />
                                </a>
                            </div>
                            <div class={`page7Item contact-red-button-transparent ${compromisSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setOffreSelected(false); setCompromisSelected(!compromisSelected); setProprietaireSelected(false); setOu_("J'ai signé mon compromis") }}>
                                    <DevisToggleItemsType1 title="J'ai signé mon compromis" icon={<FaRegHandshake class="devisIcon-1" />} />
                                </a>
                            </div>
                            <div class={`page7Item contact-red-button-transparent ${proprietaireSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setOffreSelected(false); setCompromisSelected(false); setProprietaireSelected(!proprietaireSelected); setOu_("Je suis propriétaire") }}>
                                    <DevisToggleItemsType1 title="Je suis propriétaire" icon={<VscKey class="devisIcon-1" />} />
                                </a>
                            </div>
                        </div>
                        <div class="page3ButtonsContainer">
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" onClick={() => switchView(12)}>
                                <i class="fa fa-arrow-left" ></i> <div className='ps-2'>Précédent</div>
                            </div>
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" disabled={offreSelected === false && compromisSelected === false && proprietaireSelected === false} onClick={() => switchView(13)}>
                                <div className='pe-2'>Continuer</div> <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            ) : page8 === true ? (
                <div class="" style={sofaBackgroundStyle}>
                    <div className='container pagesContainer'>
                        <div class="page3TitleContainer">
                            <div class="text-red page3Title">Quand souhaiteriez-vous commencer les travaux ?</div>
                        </div>
                        <div class="page8ItemContainer">
                            <div class={`page8Item contact-red-button-transparent ${avantSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setAvantSelected(!avantSelected); setEntreSelected(false); setApresSelected(false); setQuand("Avant " + monthNames[currentMonth1] + " " + currentYear) }}>
                                    <DevisToggleItemsType2 title={"Avant " + monthNames[currentMonth1] + " " + currentYear} icon={<ImCalendar class="devisIcon-1" />} />
                                </a>
                            </div>
                            <div class={`page8Item contact-red-button-transparent ${entreSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setAvantSelected(false); setEntreSelected(!entreSelected); setApresSelected(false); setQuand("Entre " + monthNames[currentMonth1] + " " + currentYear + " et " + monthNames[currentMonth2] + " " + currentYear) }}>
                                    <DevisToggleItemsType2 title={"Entre " + monthNames[currentMonth1] + " " + currentYear + " et " + monthNames[currentMonth2] + " " + currentYear} icon={<ImCalendar class="devisIcon-1" />} />
                                </a>

                            </div>
                            <div class={`page8Item contact-red-button-transparent ${apresSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setAvantSelected(false); setEntreSelected(false); setApresSelected(!apresSelected); setQuand("Après " + monthNames[currentMonth2] + " " + currentYear) }}>
                                    <DevisToggleItemsType2 title={"Après " + monthNames[currentMonth1] + " " + currentYear} icon={<ImCalendar class="devisIcon-1" />} />
                                </a>
                            </div>
                        </div>
                        <div class="page3ButtonsContainer">
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" onClick={() => switchView(14)}>
                                <i class="fa fa-arrow-left" ></i> <div className='ps-2'>Précédent</div>
                            </div>
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" disabled={avantSelected === false && entreSelected === false && apresSelected === false} onClick={() => switchView(15)}>
                                <div className='pe-2'>Continuer</div> <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            ) : page9 === true ? (
                <div class="" style={sofaBackgroundStyle}>
                    <div className='container pagesContainer'>
                        <div class="page3TitleContainer">
                            <div class="text-red page3Title">Pensez-vous avoir besoin d'un architecte ?</div>
                        </div>
                        <div class="page9ItemContainer">
                            <div class={`page9Item contact-red-button-transparent ${ouiSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setOuiSelected(!ouiSelected); setNonSelected(false); setAidejaSelected(false); setBesoin("Oui") }}>
                                    <DevisToggleItemsType1 title="Oui" icon={<BsHandThumbsUp class="devisIcon-1" />} />
                                </a>
                            </div>
                            <div class={`page9Item contact-red-button-transparent ${nonSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setOuiSelected(false); setNonSelected(!nonSelected); setAidejaSelected(false); setBesoin("Non") }}>
                                    <DevisToggleItemsType1 title="Non" icon={<BsHandThumbsDown class="devisIcon-1" />} />
                                </a>
                            </div>
                            <div class={`page9Item contact-red-button-transparent ${aidejaSelected ? "contact-red-button-container" : ""}`}>
                                <a onClick={() => { setOuiSelected(false); setNonSelected(false); setAidejaSelected(!aidejaSelected); setBesoin("J'en ai déjà un") }}>
                                    <DevisToggleItemsType1 title="J'en ai déjà un" icon={<MdArchitecture class="devisIcon-1" />} />
                                </a>
                            </div>
                        </div>
                        <div class="page3ButtonsContainer">
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" onClick={() => switchView(16)}>
                                <i class="fa fa-arrow-left" ></i> <div className='ps-2'>Précédent</div>
                            </div>
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" disabled={ouiSelected === false && nonSelected === false && aidejaSelected === false} onClick={() => switchView(17)}>
                                <div className='pe-2'>Continuer</div> <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>

            ) : page10 === true ? (
                <div class="" style={sofaBackgroundStyle}>
                    <div className='container pagesContainer'>
                        <div class="page3TitleContainer">
                            <div class="text-red page3Title">La qualité, les délais, le prix et le suivi de votre chantier <br /> sont nos atouts, auriez-vous d'autres critères à ajouter ?</div>
                        </div>
                        <div class="page10ItemContainer">
                            <textarea rows="4" class="page10Item" placeholder='Autres' value={autreMsg} onChange={(event) => setAutreMsg(event.target.value)}></textarea>
                        </div>
                        <div class="page3ButtonsContainer">
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" onClick={() => switchView(18)}>
                                <i class="fa fa-arrow-left" ></i> <div className='ps-2'>Précédent</div>
                            </div>
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" onClick={() => switchView(19)}>
                                <div className='pe-2'>Continuer</div> <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            ) : page11 === true ? (
                <div class="" style={sofaBackgroundStyle}>
                    <div className='container pagesContainer'>
                        <div class="page3TitleContainer">
                            <div class="text-red page3Title">Voulez-vous décrire plus en détail votre projet ?</div>
                        </div>
                        <div class="page11ItemContainer">
                            <textarea rows="4" class="page11Item" placeholder='Exemple: Nous avons acquis notre maison …' value={detailProjet} onChange={(event) => setDetailProjet(event.target.value)}></textarea>
                        </div>
                        <div class="page3ButtonsContainer">
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" onClick={() => switchView(20)}>
                                <i class="fa fa-arrow-left" ></i> <div className='ps-2'>Précédent</div>
                            </div>
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" onClick={() => switchView(21)}>
                                <div className='pe-2'>Continuer</div> <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            ) : page12 === true ? (

                <div class="" style={sofaBackgroundStyle}>
                    <div className='container pagesContainer'>
                        <div class="page3TitleContainer">
                            <div class="text-red page3Title">Voulez-vous décrire plus en détail votre projet ?</div>
                        </div>
                        <div class="page12ItemContainer">
                            <div class="page12Item1 mt-3">
                                <select type="text" class="" placeholder='Civilité' value={civilite} onChange={(event) => setCivilite(event.target.value)} >
                                    <option class="" hidden>Civilité</option>
                                    <option class="">M.</option>
                                    <option class="">Mme.</option>
                                </select>
                            </div>
                            <div class="page12Item2"><input type="text" class="" placeholder='Nom' value={nom} onChange={(event) => setNom(event.target.value)} /></div>
                            <div class="page12Item3">
                                <input type="text" class="" placeholder='Prénom' value={prenom} onChange={(event) => setPrenom(event.target.value)} />
                            </div>
                            <div class="page12Item4">
                                <input type="text" class="" placeholder='Téléphone' minLength={5} maxLength={20} value={telephone} onChange={(e) => {
                                    let currentValue = e.target.value;
                                    const telephoneRegex = /^(\+[0-9]{0,1})?[0-9]*$/;

                                    if (telephoneRegex.test(currentValue)) {
                                        setTelephone(currentValue);
                                    }
                                }} />
                            </div>
                            <div class="page12Item5">
                                <input type="mail" class="" placeholder='Adresse mail' value={mail} onChange={(event) => setMail(event.target.value)} />
                            </div>
                        </div>
                        <div class="page3ButtonsContainer">
                            <div className="cursor-pointer contact-buttons d-flex justify-content-center align-items-center" onClick={() => switchView(22)}>
                                <i class="fa fa-arrow-left" ></i> <div className='ps-2'>Précédent</div>
                            </div>
                            <div className="cursor-pointer contact-buttons" disabled={!civilite || !nom || !prenom || !telephone || !mail} onClick={() => { validateFields(); }}>
                                Envoyer
                            </div>
                        </div>
                    </div>
                </div>

            ) : <></>
            }
            <FooterComponent />
        </div >
    );
}

export default Contact;
